import { styled } from 'styled-components';

import {
  bodyText,
  cssBreakpoints,
  gutterWidth,
  h2Text,
  maxWidth,
} from 'theme/theme';

export const UnpublishedListingHolder = styled.div`
  margin: 70px auto;
  max-width: ${maxWidth[4]}px;
  padding: 0 ${gutterWidth / 2}px;
`;

export const UnpublishedListingSearchContextHeaderHolder = styled.div`
  margin-bottom: 32px;
`;

export const UnpublishedListingUpperSection = styled.section`
  display: flex;
  gap: 83px;
  margin-bottom: 70px;
  align-items: center;

  @media screen and (max-width: ${cssBreakpoints.mdDown}) {
    flex-direction: column;
    align-items: stretch;
    gap: 32px;
  }
`;

export const UnpublishedListingUpperSectionAnimation = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  padding-bottom: 32px;
`;

export const UnpublishedListingUpperSectionAnimationHolder = styled.div`
  width: 100%;
  max-width: 586px;
`;

export const UnpublishedListingUpperSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const UnpublishedListingUpperSectionHeader = styled.header({});

export const UnpublishedListingUpperSectionHeaderTitle = styled.h1`
  ${h2Text};

  margin: 0;
  max-width: 416px;
`;

export const UnpublishedListingUpperSectionSeeMore = styled.div`
  ${bodyText};
  max-width: 416px;
`;

export const UnpublishedListingUpperSectionFooter = styled.footer`
  margin-top: 43px;
  max-width: 360px;
`;

export const UnpublishedListingUpperSectionFooterSearchField = styled.div`
  display: flex;
  gap: 16px;
`;

export const UnpublishedListingExploreSection = styled.section`
  max-width: ${maxWidth[3]}px;
  margin: 70px auto 0;
  padding: 0 ${gutterWidth / 2}px;
`;
